import logo from "../../assets/img/logo_20250311.png";
import logo2x from "../../assets/img/logo_20250311@2x.png";

const LoginHeader = ({ title, logoDirection="col"}: {title: string, logoDirection?: string}) => {
    return (
        <header>
            <div className="md:p-0 p-4 pb-2 md:border-b-0 border-b border-[#E0E0E0;] relative">
                <div className={`flex items-center justify-center ${logoDirection === "row" ? "flex-row" : "flex-col"} gap-2`}>
                    <span className='md:hidden'>
                        <img src={logo}
                            srcSet={`${logo} 1x, ${logo2x} 2x`}
                            alt="aloop logo" 
                            width="103" 
                            height="27"
                        />
                    </span>
                    <h2 className="text-xl font-bold text-center alu-text-base-2">{title}</h2>
                </div>
            </div>
        </header>
    );
};

export default LoginHeader;